class MyEventEmitter {
    constructor() {
      this._events = {};
    }
  
    on(name, listener) {
      if (!Object.hasOwn(this._events, name)) {
        this._events[name] = [];
      }
  
      this._events[name].push(listener);
    }
  
    removeListener(name, listenerToRemove) {
      if (!Object.hasOwn(this._events, name)) {
          return
        //throw new Error(`Can't remove a listener. Event "${name}" doesn't exits.`);
      }
  
      const filterListeners = (listener) => listener !== listenerToRemove;
  
      this._events[name] = this._events[name].filter(filterListeners);
    }
  
    emit(name, data) {
      if (!Object.hasOwn(this._events, name)) {
          return
       // throw new Error(`Can't emit an event. Event "${name}" doesn't exits.`);
      }
  
      const fireCallbacks = (callback) => {
        callback(data);
      };
  
      this._events[name].forEach(fireCallbacks);
    }
  }

  export {MyEventEmitter}